import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

// Injecter le token JWT dans chaque requête
API.interceptors.request.use(config => {
  const token = localStorage.getItem('escamel_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

// Rediriger vers /login si 401
API.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('escamel_token');
      localStorage.removeItem('escamel_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export function useApi(endpoint, deps = []) {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  const fetch = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await API.get(endpoint);
      setData(res.data);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  }, [endpoint]); // eslint-disable-line

  useEffect(() => { fetch(); }, [fetch, ...deps]);

  return { data, loading, error, refetch: fetch };
}

// Construit une URL /uploads/... qui marche à la fois en dev (CRA :3000 → backend :3001)
// et en prod (LiteSpeed proxy via .htaccess sur le même origin).
export function uploadUrl(path) {
  if (!path) return '';
  const clean = String(path).startsWith('/') ? path : `/${path}`;
  if (window.location.port === '3000') {
    return `http://${window.location.hostname}:3001${clean}`;
  }
  return clean;
}

export const api = {
  get:      (url)          => API.get(url).then(r => r.data),
  post:     (url, data)    => API.post(url, data).then(r => r.data),
  put:      (url, data)    => API.put(url, data).then(r => r.data),
  patch:    (url, data)    => API.patch(url, data).then(r => r.data),
  delete:   (url)          => API.delete(url).then(r => r.data),
  blob:     (url)          => API.get(url, { responseType: 'blob' }).then(r => r.data),
  postForm: (url, formData) => API.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data),
  putForm:  (url, formData) => API.put(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data),
};

export default api;
